<template>
    <CodeEditor :btnLabel="$t('advancedFilters')" v-model="content" :libs="libs" :vars="vars" :snippets="snippets">
        <b-btn variant="success" @click="apply">{{ $t('apply') }}</b-btn>
    </CodeEditor>
</template>

<script>
import CodeEditor from '@/components/form/Editor/Code'

export default {
    name: 'AdvancedFilters',
    components: {
        CodeEditor
    },
    props: {
        value: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            expr: '',
            snippets: [
                {text: 'filters.filter', displayText: 'filters.filter', info: 'Set filter for search'},
                {text: 'filters.dateField', displayText: 'filters.dateField', info: 'Available date field from dropdown'},
                {text: 'filters.dateFrom', displayText: 'filters.dateFrom'},
                {text: 'filters.dateTo', displayText: 'filters.dateTo'},
                {text: 'filters.setAdvFilters({})', displayText: 'filters.setAdvFilters()', info: 'Set advanced filters for more in depth search', docs: this.$env.get('DOCS_URL') + "/docs#libs-filters"},
                {text: 'filters.setFilterOn([])', displayText: 'filters.setFilterOn()', info: 'Set fields on which filter will be applied on', docs: this.$env.get('DOCS_URL') + "/docs#libs-filters"}
            ]
        }
    },

    computed: {
        content: {
            get() {
                return this.value
            },

            set(val) {
                this.expr = val
            }
        },

        vars() {
            return [
            ]
        } ,

        libs() {
            return  [
                {
                    name: "lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                },
                {
                    name: "moment",
                    varName: "moment",
                    docs: "https://momentjs.com/"
                },
                {
                    name: "protokol/filters",
                    varName: "filters",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-filters"
                }
            ]
        },
    },

    methods: {
        apply() {
            this.$emit('apply', this.expr);
        }
    }
}
</script>
